import { useState, useEffect } from 'react';
import { useTheme } from '../contexts/ThemeContext';
import { useFont } from '../contexts/FontContext';
import { X, Settings } from 'lucide-react';

export default function CookieConsent() {
  const { theme } = useTheme();
  const { font } = useFont();
  const [isVisible, setIsVisible] = useState(false);
  const [showCustomize, setShowCustomize] = useState(false);
  const [analyticsEnabled, setAnalyticsEnabled] = useState(true);

  useEffect(() => {
    const consent = localStorage.getItem('cookieConsent');
    if (!consent) {
      setIsVisible(true);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem('cookieConsent', JSON.stringify({ analytics: analyticsEnabled }));
    window.gtag?.('consent', 'update', { analytics_storage: analyticsEnabled ? 'granted' : 'denied' });
    setIsVisible(false);
  };

  const handleDecline = () => {
    localStorage.setItem('cookieConsent', 'declined');
    setIsVisible(false);
  };

  const handleCustomize = () => {
    setShowCustomize(!showCustomize);
  };

  if (!isVisible) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 bg-white border-t border-gray-200 shadow-lg z-50" style={{ fontFamily: font.family }}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
        <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
          <div className="flex-1">
            <p className="text-gray-600">
              Ce site utilise des cookies pour assurer votre connexion et mesurer l'audience (Google Analytics).
            </p>
          </div>
          <div className="flex items-center gap-4">
            <button
              onClick={handleCustomize}
              className="px-4 py-2 text-gray-600 hover:text-gray-900 transition-colors"
            >
              Personnaliser
            </button>
            <button onClick={handleDecline} className="px-4 py-2 text-gray-600 hover:text-gray-900 transition-colors">
              Refuser
            </button>
            <button
              onClick={handleAccept}
              className={`px-6 py-2 bg-${theme.primary} text-white rounded-lg hover:opacity-90 transition-opacity`}
            >
              Accepter
            </button>
          </div>
          <button
            onClick={handleDecline}
            className="absolute top-2 right-2 sm:hidden p-2 text-gray-400 hover:text-gray-600"
          >
            <X className="h-5 w-5" />
          </button>
        </div>
        {showCustomize && (
          <div className="mt-4 border-t border-gray-200 pt-4">
            <div className="flex items-center justify-between">
              <div>
                <h3 className="font-medium mb-1">Google Analytics</h3>
                <p className="text-sm text-gray-500">
                  Mesure de l'audience et des performances du site
                </p>
              </div>
              <label className="relative inline-flex items-center cursor-pointer">
                <input
                  type="checkbox"
                  checked={analyticsEnabled}
                  onChange={(e) => setAnalyticsEnabled(e.target.checked)}
                  className="sr-only peer"
                />
                <div className={`w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-${theme.secondary} rounded-full peer peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:start-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-${theme.primary}`}></div>
              </label>
            </div>
            <div className="flex justify-end mt-4">
              <button onClick={handleAccept} className={`px-6 py-2 bg-${theme.primary} text-white rounded-lg hover:opacity-90 transition-opacity`}>
                Enregistrer mes préférences
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}